import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, toDisplayString as _toDisplayString, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-39cb0bbc"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "tab-container" }
const _hoisted_2 = { class: "dual-field-container" }
const _hoisted_3 = { class: "column" }
const _hoisted_4 = { class: "column" }
const _hoisted_5 = { class: "dual-field-container" }
const _hoisted_6 = { class: "column" }
const _hoisted_7 = { class: "column" }
const _hoisted_8 = { class: "tab-container" }
const _hoisted_9 = { class: "setting-toggles" }
const _hoisted_10 = { class: "tab-container" }
const _hoisted_11 = { class: "tab-container" }
const _hoisted_12 = { key: 0 }
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Message Body", -1))
const _hoisted_14 = { class: "preview-body-container" }
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { id: "preview-body" }, null, -1))
const _hoisted_16 = {
  key: 2,
  class: "navigator-excluder-section"
}
const _hoisted_17 = { class: "contact-navigator" }
const _hoisted_18 = { class: "tab-container email-container" }
const _hoisted_19 = { class: "email-cell" }
const _hoisted_20 = { class: "email" }
const _hoisted_21 = ["onClick"]
const _hoisted_22 = { class: "include-cell" }

import { computed, ref, watch, inject, onMounted, PropType } from "vue";
import ModalBase from "@/components/ui/modals/modal-base.vue";
import { DxToolbarItem } from "devextreme-vue/popup";
import { DxTabPanel, DxItem } from "devextreme-vue/tab-panel";
import AcquaintInfoBox from "@/components/ui/inputs/acquaint-info-box.vue";
import AcquaintTextbox from "@/components/ui/inputs/acquaint-textbox.vue";
import ContactLookup from "@/components/ui/lookup/contact-lookup.vue";
import PropertyLookup from "@/components/ui/lookup/property-lookup.vue";
import HtmlEditor from "@/components/html-editor/html-editor.vue";
import SwitchToggle from "@/components/ui/toggles/switch-toggle.vue";
import SelectCcContactsModal from "@/components/contacts/select-cc-contacts-modal.vue";
import MergeFieldsModal from "@/components/contacts/merge-fields-modal.vue";
import { EmailForm } from "@/types/emails/EmailForms";
import { ContactFindResult } from "@/types/find/contacts/ContactFindResult";
import { EmailsValidation } from "acquaint-api/validation/EmailsValidation";
import displayErrorMessage from "@/utils/ErrorHandling";
import { getErrorMessage } from "bright-logic-core/src/errors";
import { AcquaintApiClient } from "@/services/AcquaintApiClient";
import { AcquaintApiNextClient } from "@/services/AcquaintApiNextClient";
import { ContactSummary } from "@/types/contacts/ContactSummary";
import { useCurrentUserStore } from "@/stores/CurrentUserStore";
import { CurrentUser } from "@/types/user/CurrentUser";
import { EmailPreviewFields } from "@/types/emails/EmailPreviewFields";
import { ValidatedEvent } from "devextreme/ui/validator";
import { ModalWidth } from "@/types/ui/modals/ModalWidth";
import FileUpload from "@/components/ui/inputs/file-upload.vue";
import { EmailTab } from "@/enums/correspondence/EmailTab";
import { FieldSize } from "@/enums/system/FieldSize";
import { CorrespondenceEmail } from "@/types/CorrespondenceEmail";
import { formatDate } from "bright-logic-core/src/format";
import { UserDetails } from "@/types/users/UserDetails";
import { EmailTemplateFile } from "@/types/EmailTemplateFile";
import {
  getFileNameParts,
  convertCorrespondenceFileToBlob,
} from "@/utils/files/CorrespondenceFileConverter";
import { saveAs } from "file-saver-es";
import { FileNameId } from "@/types/FileNameId";
import { EmailSignatures } from "acquaint-api/models/EmailSignatures";
import { SelectedEmailAction } from "@/enums/emails/SelectedEmailAction";
import { standardInfoAlert } from "@/alerts/standardInfoAlert";
import { BulkEmailResponse } from "@/types/emails/BulkEmailResponse";
import { Body } from "@/types/generic/Body";
import { PropertyBulletinPreview } from "@/types/emails/PropertyBulletinPreview";
import { EmailTemplateTypes } from "@/enums/emails/EmailTemplateTypes";
import ScrollView from "@/components/ui/scroll-view.vue";
import GridBase from "@/components/ui/grid/grid-base.vue";
import { DxColumn } from "devextreme-vue/data-grid";
import { MatchedContacts } from "@/types/matching/MatchedContacts";
import { DisplayedMatchContacts } from "@/types/matching/DisplayedMatchedContacts";
import EditContactDetails from "@/components/contacts/record/edit-contact-details.vue";
import { Contacts } from "acquaint-api/models/Contacts";
import { useSystemConfigurationStore } from "@/stores/SystemConfigurationStore";
import { SystemConfiguration } from "acquaint-api/constants/SystemConfiguration";
import { EmailTemplate } from "@/types/EmailTemplate";
import AITextGeneratorModal from "@/components/ai/ai-text-generator-modal.vue";
import { CorrespondenceFile } from "@/types/CorrespondenceFile";


export default /*#__PURE__*/_defineComponent({
  __name: 'email-form-modal',
  props: {
  /**
   * The boolean value used with `v-model` to control the visibility or state of a modal or component.
   * @type {boolean}
   * @required
   */
  modelValue: {
    type: Boolean,
    required: true,
  },

  /**
   * The ID of the email template to be used.
   * @type {number}
   * @required
   */
  emailTemplateId: {
    type: Number,
    required: true,
  },

  /**
   * The ID of the property related to the email or action.
   * @type {number}
   * @default 0
   */
  propertyRelatedToId: {
    type: [Number, Array] as PropType<number | number[]>,
    default: 0,
  },

  /**
   * A list of contact IDs to be used for the email or action.
   * @type {number[]}
   * @default [] (empty array)
   */
  contactList: {
    type: Array as PropType<number[]>,
    default: () => [],
  },

  /**
   * A list of matched contacts for bulk email operations.
   * @type {MatchedContacts[]}
   * @default [] (empty array)
   */
  contactEnMasseList: {
    type: Array as PropType<MatchedContacts[]>,
    default: () => [],
  },

  /**
   * The email object to be forwarded.
   * @type {CorrespondenceEmail}
   * @default {} (empty object)
   */
  emailToForward: {
    type: Object as PropType<CorrespondenceEmail>,
    default: () => ({}),
  },

  /**
   * The ID of the user performing the action.
   * @type {number}
   * @default 0
   */
  userId: {
    type: Number,
    default: 0,
  },

  /**
   * The ID of the email to be forwarded.
   * @type {number}
   * @default 0
   */
  emailToForwardId: {
    type: Number,
    default: 0,
  },

  /**
   * The selected email action (e.g., new, reply, forward).
   * @type {SelectedEmailAction}
   * @default SelectedEmailAction.New
   */
  actionSelected: {
    type: Number,
    default: SelectedEmailAction.New,
  },

  /**
   * The unique identifier for the certificate.
   * @type {number}
   * @default 0
   */
  certificateId: {
    type: Number,
    default: 0,
  },

  /**
   * A list of file IDs associated with the correspondence.
   * @type {number[]}
   * @default [] (empty array)
   */
  correspondenceFileIDs: {
    type: Array as PropType<number[]>,
    default: () => [],
  },

  /**
   * Determines whether the "Select Contacts" tab should be displayed.
   * @type {boolean}
   * @default false
   */
  displaySelectContactsTab: {
    type: Boolean,
    default: false,
  },

  /** Id of the contact related to the property feedback being sent
   * @type {number}
   * @default 0
   */
  propertyFeedbackContactId: {
    type: Number,
    default: 0,
  },
  /** Id of the appointment
   * @type {number}
   * @default 0
   */
  appointmentId: {
    type: Number,
    default: 0,
  },
  /**
   * The unique identifier for the work order.
   * @type {number}
   * @default 0
   */
  workOrderId: {
    type: Number,
    default: 0,
  },
  /**
   * Default files
   */
  defaultFiles: {
    type: Array as PropType<File[]>,
    default: () => {
      return [];
    },
  },
  /**
   * This is used when emailing landlords and tenants per property from the tenancy list screens
   */
  emailingContactsPerProperty: {
    type: Boolean,
    default: false,
  },
},
  emits: [
  /**
   * Triggered when the `modelValue` changes. This is used to update the v-model variable in the parent component.
   * @property {boolean} value - Indicates whether the modal has been opened or closed.
   */
  "update:modelValue",
  /**
   * Emitted when the email has been sent.
   * This can be used to notify the parent component that the email has been sent.
   */
  "emailSent",
  /**
   * Emitted when the modal is closed.
   * This can be used to notify the parent component that the modal has been dismissed.
   */
  "modalClosed",
  /**
   * Emitted when the modal is cancel Prompt Accepted.
   * This can be used to notify the parent component that the cancel Prompt has been Accepted.
   */
  "cancelPromptAccepted",
],
  setup(__props, { emit }) {

const props = __props;





const showModal = computed({
  get: () => props.modelValue,
  set: (value: boolean) => emit("update:modelValue", value),
});

const keepingModalOpening = ref(false);
const currentUserStore = useCurrentUserStore();
const currentUser = ref<CurrentUser>();
const selectedTab = ref(EmailTab.Customise);
const openSelectCcContactModal = ref(false);
const updateCopyContacts = ref(false);
const copyToContactNames = ref("");
const blindCopyToContactsNames = ref("");
const copyToContactsNamesEmails = ref("");
const addMergeFieldToSubject = ref(true);
const clearLists = ref(false);
const showCloseConfirmationPrompt = ref(true);
const attachments = ref<File[]>([]);
const azureEmailAddress = ref("");
const apiAttachmentsList = ref<EmailTemplateFile[]>([]);
const originalCorrespondenceFileList = ref<File[]>([]);
// The value of the ref is set when a file is double selected and downloaded.
const downloadedFile = ref<EmailTemplateFile>();
// We have the originalFilesIdsNames so that we can determine whether a file to be downloaded was fetched from the API and
// therefore if we need to call the download API or just save the file using saveAs.
const originalFilesIdsNames = ref<FileNameId[]>([]);
const resetFileField = ref(false);
const selectedContactId = ref(0);
const contactNamesEmails = ref<string[]>([]);
const contactSummary = ref<ContactSummary>();
const userDetails = ref<UserDetails>();
const emailSignature = ref<EmailSignatures>();
const displayEditContactModal = ref(false);
const contactToEmail = ref<Contacts>();
const previouslyNavigatedThroughIds = ref<number[]>([]);
const emailForm = ref<EmailForm>({
  contactId: 0,
  templateId: 0,
  subject: "",
  body: "",
  propertyId: 0,
  workOrderId: 0,
  propertyOfferId: 0,
  certificateId: 0,
  tenancyId: 0,
  appointmentId: 0,
  propertyFeedbackContactId: 0,
  cCs: [],
  bcCs: [],
  setAsHighPriority: false,
  requestReadReceipt: false,
  autoCcLinkedContacts: true,
  contactDocumentIds: [],
});
const openMergeFieldsModal = ref(false);
const emailTemplate = ref<EmailTemplate>();
const apiClient = inject("AcquaintApiClient") as AcquaintApiClient;
const apiNextClient = inject("AcquaintApiNextClient") as AcquaintApiNextClient;
const bodyMergeFieldToAdd = ref("");
const sendingOrSaving = ref(false);
const credits = ref(0);
const filesToSubmit = ref(new FormData());
const currentContactPosition = ref(0);
const toEditEmailId = ref(-1);
const copiedContactList = ref<DisplayedMatchContacts[]>([]);
const systemConfigurationStore = useSystemConfigurationStore();
const propertyBulletinText = ref<PropertyBulletinPreview>({
  body: "",
  noPropertiesFound: false,
});
const emailPreviewFields = ref<EmailPreviewFields>({
  subject: "",
  body: "",
});
const showPreviewTab = ref(true);
const propertyDetails = ref<Body>({ body: "" });
const newsLetterBody = ref<Body>({ body: "" });
const displayAIModal = ref(false);
const loading = ref(false);
const furthestContactVisited = ref(0);

// This calculates the property id for each email
// In the tenancy list, users may want to email tenants and landlords per property
// and so the property id must be set correctly for each contact.
const returnPropertyId = (position: number) => {
  if (
    Array.isArray(props.propertyRelatedToId) &&
    props.propertyRelatedToId.length > 0
  ) {
    return props.propertyRelatedToId[position];
  } else if (
    Array.isArray(props.propertyRelatedToId) &&
    props.propertyRelatedToId.length == 0
  ) {
    return 0;
  } else if (!Array.isArray(props.propertyRelatedToId)) {
    return props.propertyRelatedToId;
  }

  return 0;
};

onMounted(async () => {
  currentUser.value = await currentUserStore.getCurrentUserDetails();
});

// This retrieves and displays the data
watch(
  () => showModal.value,
  async () => {
    if (keepingModalOpening.value || !showModal.value) {
      clearLists.value = true;
      setTimeout(() => {
        clearLists.value = false;
      }, 100);
      return;
    }

    loading.value = true;
    currentContactPosition.value = 0;
    furthestContactVisited.value = 0;

    await resetEmailFormToDefaults();
    await fetchEmailTemplateData();
    await getEmailCredits();

    if (azureEmailAddress.value == "") {
      await fetchAzureEmailFromAddress();
    }

    cloneContactList();

    // So users can preview what properties are going to be sent, default property bulletin templates to the preview tab
    selectedTab.value = isMarketingHtmlEmailTemplate.value
      ? EmailTab.Preview
      : EmailTab.Customise;

    await moveDataToEmailForm();

    loading.value = false;

    // This must be called after the loading value has been reset. Otherwise the preview won't be generated
    await fetchPreviewSubjectBody();
  },
);

const resetEmailFormToDefaults = async () => {
  const autoCC = await systemConfigurationStore.getSystemConfigurationValue(
    SystemConfiguration.AutoCCLinkedContactsInBulkEmails,
  );

  let property = 0;
  if (
    Array.isArray(props.propertyRelatedToId) &&
    props.propertyRelatedToId.length > 0
  ) {
    property = props.propertyRelatedToId[0];
  } else if (
    Array.isArray(props.propertyRelatedToId) &&
    props.propertyRelatedToId.length == 0
  ) {
    property = 0;
  } else if (!Array.isArray(props.propertyRelatedToId)) {
    property = props.propertyRelatedToId;
  }

  // If multiple contact have been passed down, we want the contact lookup up to be empty
  emailForm.value = {
    contactId: 0,
    templateId: 0,
    subject: "",
    body: "",
    propertyId: property,
    workOrderId: props.workOrderId,
    propertyOfferId: 0,
    certificateId: props.certificateId,
    tenancyId: 0,
    appointmentId: props.appointmentId,
    propertyFeedbackContactId: props.propertyFeedbackContactId,
    cCs: [],
    bcCs: [],
    setAsHighPriority: false,
    requestReadReceipt: false,
    autoCcLinkedContacts: Number(autoCC) ? true : false,
    contactDocumentIds: [],
  };

  if (props.displaySelectContactsTab) {
    emailForm.value.contactId =
      props.contactEnMasseList.length > 1 ? 0 : props.contactEnMasseList[0].id;
  } else {
    emailForm.value.contactId =
      props.contactList.length > 1 ? 0 : props.contactList[0];
  }

  showPreviewTab.value = true;
  resetFileField.value = true;
  attachments.value = [];
  apiAttachmentsList.value = [];
  originalFilesIdsNames.value = [];
  filesToSubmit.value = new FormData();
  setTimeout(() => {
    resetFileField.value = false;
  }, 200);
  copyToContactsNamesEmails.value = "";
  copyToContactNames.value = "";
  blindCopyToContactsNames.value = "";
  showCloseConfirmationPrompt.value = true;
  addMergeFieldToSubject.value = true;
  selectedContactId.value = props.displaySelectContactsTab
    ? props.contactEnMasseList[0].id
    : props.contactList[0];
  contactNamesEmails.value = [];
  contactSummary.value = undefined;
  previouslyNavigatedThroughIds.value = [];
  copiedContactList.value = [];
};

const cloneContactList = () => {
  if (props.displaySelectContactsTab) {
    copiedContactList.value = props.contactEnMasseList.map((contact) => {
      return {
        id: contact.id,
        name: contact.name ?? "",
        email: contact.email ?? "",
        emailAlt: contact.emailAlt ?? "",
        include: true,
      };
    });
  } else {
    copiedContactList.value = [];
  }
};

const moveDataToEmailForm = async () => {
  emailForm.value.templateId = emailTemplate.value?.id ?? -1;
  emailForm.value.subject = emailTemplate.value?.subject ?? "";
  emailForm.value.cCs = emailTemplate.value?.cc
    ? [Number(emailTemplate.value.cc)]
    : [];
  emailForm.value.bcCs = emailTemplate.value?.bcc
    ? [Number(emailTemplate.value.bcc)]
    : [];

  if (emailTemplate.value && !isMarketingHtmlEmailTemplate.value) {
    await fetchEmailSignature();

    emailForm.value.body =
      emailSignature.value?.header != ""
        ? `${emailSignature.value?.header} <br /><br />`
        : "";
    emailForm.value.body =
      emailForm.value.body +
      `${emailTemplate.value.body.replaceAll("&edsp;", "")}`;

    if (emailSignature.value?.body == "") {
      return;
    }

    emailForm.value.body =
      emailForm.value.body + `<br /><br /> ${emailSignature.value?.body}`;
  }

  if (isMarketingHtmlEmailTemplate.value) {
    emailForm.value.body = emailTemplate.value
      ? `${emailTemplate.value.body.replaceAll("&edsp;", "")}`
      : "";
  }

  if (props.actionSelected == SelectedEmailAction.New) {
    attachments.value = [...attachments.value, ...props.defaultFiles];
    await populateOriginalAttachmentsList();
  } else if (props.actionSelected != SelectedEmailAction.New) {
    await displayForwardedEmailAttachments();
    await fetchUserDetails();
    emailForm.value.subject = props.emailToForward.subject;
    const subjectInBody = props.emailToForward.subject.includes("Fw: ")
      ? props.emailToForward.subject.replace("FW: ", "")
      : props.emailToForward.subject.replace("RE: ", "");
    emailForm.value.body =
      `${emailTemplate.value?.body ?? ""}` +
      `${
        userDetails.value
          ? `<br><br>From: ${userDetails.value.firstNames} ${userDetails.value?.lastName}`
          : ""
      }` +
      "<br>" +
      `Date Sent: ${formatDate(props.emailToForward.addedDate, true)}` +
      "<br>" +
      `To: ${props.emailToForward.email}` +
      "<br>" +
      `Subject: ${subjectInBody}` +
      "<br>" +
      props.emailToForward.body +
      "<br>";
  }

  // When the modal is opened from the property page, multiple contacts can be provided.
  // When a contact is opened from a contact page, only one contact is provided
  await updatedNamesEmailList(
    props.displaySelectContactsTab
      ? props.contactEnMasseList[0].id
      : props.contactList[0],
    currentContactPosition.value,
  );
};

const isMarketingHtmlEmailTemplate = computed(() => {
  if (!emailTemplate.value) {
    return false;
  }

  return (
    emailTemplate.value.typeId ==
      EmailTemplateTypes.PropertyBulletinAllProperties ||
    emailTemplate.value.typeId ==
      EmailTemplateTypes.PropertyBulletinMatchedProperties ||
    emailTemplate.value.typeId == EmailTemplateTypes.PropertyDetails ||
    emailTemplate.value?.typeId == EmailTemplateTypes.NewsLetter
  );
});

// Functions fetch data to be displayed
const updatedNamesEmailList = async (contactId: number, position: number) => {
  const summary = await fetchSendToContactData(contactId);

  if (!summary) {
    return;
  }

  contactNamesEmails.value.push(`${summary.name} - ${summary.emailAddress}`);
  contactSummary.value = summary;

  if (
    contactNamesEmails.value.length == 0 ||
    !contactNamesEmails.value[position].includes("@")
  ) {
    await standardInfoAlert(
      `${summary?.name} has no email address and cannot be emailed.`,
    );
  }
};

const fetchSendToContactData = async (id: number) => {
  try {
    return await apiClient.httpGet<ContactSummary>(
      `app/contacts/${id}/summary`,
    );
  } catch (ex) {
    displayErrorMessage(getErrorMessage(ex));
    return undefined;
  }
};

const fetchAzureEmailFromAddress = async () => {
  try {
    azureEmailAddress.value = await apiNextClient.httpGet(
      "/Email/GetAzureEmailFromAddress",
    );
  } catch (err) {
    displayErrorMessage(getErrorMessage(err));
    azureEmailAddress.value = "";
  }
};

const fetchUserDetails = async () => {
  try {
    userDetails.value = await apiClient.httpGet<UserDetails>(
      `app/user/record/${props.userId}`,
    );
  } catch (err) {
    userDetails.value = undefined;
  }
};

const fetchEmailSignature = async () => {
  try {
    emailSignature.value = await apiNextClient.httpGet(
      `EmailSignatures/${emailTemplate.value?.emailSignatureId}`,
    );
  } catch (err) {
    displayErrorMessage(getErrorMessage(err));
    emailSignature.value = undefined;
  }
};

const fetchEmailTemplateData = async () => {
  try {
    emailTemplate.value = await apiNextClient.httpGet<EmailTemplate>(
      `EmailTemplates/${props.emailTemplateId}`,
    );
  } catch (err) {
    displayErrorMessage(getErrorMessage(err));
    emailTemplate.value = undefined;
  }
};

const getEmailCredits = async () => {
  credits.value = await apiNextClient.httpGet("/Email/getemailcreditbalance");
};

// Functions for getting and displaying the appropriate files.
const populateOriginalAttachmentsList = async () => {
  sendingOrSaving.value = true;
  await fetchEmailAttachmentsList();

  // This is triggered when users are sending attachments from a correspondence list e.g. multiple attachments or a doc/docx as a PDF.
  if (props.correspondenceFileIDs.length > 0) {
    for (let i = 0; i < props.correspondenceFileIDs.length; i++) {
      const attachment: undefined | CorrespondenceFile =
        await fetchCorrespondenceFile(props.correspondenceFileIDs[i]);

      if (!attachment) {
        continue;
      }

      apiAttachmentsList.value.push({
        id: props.correspondenceFileIDs[i],
        emailId: props.correspondenceFileIDs[i],
        attachedFile: attachment,
      });
    }
  }
  await populateAttachmentsList(apiAttachmentsList.value);
  sendingOrSaving.value = false;
};

const fetchEmailAttachmentsList = async () => {
  try {
    apiAttachmentsList.value = await apiNextClient.httpGet(
      `email/${props.emailTemplateId}/emailattachments`,
    );
  } catch (err) {
    displayErrorMessage(
      "Unable to retrieve attachments for the selected template. To resolve this please check the Email Template configuration. You are still able to send this email.",
    );
    apiAttachmentsList.value = [];
  }
};

const fetchCorrespondenceFile = async (fileId: number) => {
  try {
    return await apiNextClient.httpGet<CorrespondenceFile>(
      `ContactDocument/${fileId}`,
    );
  } catch (err) {
    displayErrorMessage("The correspondence file could not be fetched.");
    return;
  }
};

const fetchForwardedEmailAttachmentsList = async (): Promise<
  EmailTemplateFile[]
> => {
  try {
    return await apiNextClient.httpGet(
      `email/${props.emailToForwardId}/contactemailattachments`,
    );
  } catch (err) {
    displayErrorMessage("The attachments list could not be fetched.");
    return [];
  }
};

const populateAttachmentsList = async (attachmentList: EmailTemplateFile[]) => {
  if (attachmentList.length == 0) {
    return;
  }

  attachmentList.forEach((file) => {
    if (!file.attachedFile) {
      return;
    }

    const fileName = getFileNameParts(file.attachedFile.fileDownloadName);

    if (!fileName) {
      displayErrorMessage(
        `${file.attachedFile.fileDownloadName} could not be attached as there is a problem with it's name. You are still able to send this email.`,
      );
      return;
    }

    // When a user is sending a .docx file as a PDF from a correspondence list screen, we want the file displayed to the user in the file uploader component
    // so they can download it locally and view it but we don't want the file being uploaded to the bulk email attachments endpoint
    originalFilesIdsNames.value.push({
      id: file.id,
      name: fileName.nameWithExtension,
    });
    attachments.value.push(
      new File([file.attachedFile.fileContents], fileName.nameWithExtension, {
        type: file.attachedFile.contentType,
      }),
    );

    const correspondenceAttachment = props.correspondenceFileIDs.find((id) => {
      return id == file.id;
    });
    if (correspondenceAttachment) {
      originalCorrespondenceFileList.value.push(
        new File([file.attachedFile.fileContents], fileName.nameWithExtension, {
          type: file.attachedFile.contentType,
        }),
      );
    }
  });
};

const displayForwardedEmailAttachments = async () => {
  if (props.actionSelected == SelectedEmailAction.Reply) {
    return;
  }

  const list: EmailTemplateFile[] = await fetchForwardedEmailAttachmentsList();

  populateAttachmentsList(list);
};

// Code for saving data
const onSendClick = async (e: any) => {
  // We seem to have two checks for this now, will check next week if this one is actually still necessary, which I doubt
  // Currently, we are only checking if the first contact has given permission as we don't have
  // the API for sending multiple emails

  const validation: ValidatedEvent = e.validationGroup.validate();

  // Don't continue if user has entered invalid data
  if (!validation.isValid) {
    selectedTab.value = EmailTab.Customise;
    return;
  }

  let emailFormsToSubmit: EmailForm[] = [];

  if (
    emailTemplate.value?.typeId ==
      EmailTemplateTypes.PropertyBulletinAllProperties ||
    emailTemplate.value?.typeId ==
      EmailTemplateTypes.PropertyBulletinMatchedProperties
  ) {
    emailForm.value.body = propertyBulletinText.value.body;
  } else if (
    emailTemplate.value?.typeId == EmailTemplateTypes.PropertyDetails
  ) {
    emailForm.value.body = propertyDetails.value.body;
  } else if (emailTemplate.value?.typeId == EmailTemplateTypes.NewsLetter) {
    emailForm.value.body = newsLetterBody.value.body;
  }

  // The selected correspondence list document needs to be sent as a PDF
  if (props.correspondenceFileIDs.length > 0) {
    emailForm.value.contactDocumentIds = [...props.correspondenceFileIDs];
  }

  if (props.displaySelectContactsTab) {
    copiedContactList.value.forEach((contact, index) => {
      if (!contact.include) {
        return;
      }

      emailFormsToSubmit.push({
        contactId: contact.id,
        templateId: props.emailTemplateId,
        subject: emailForm.value.subject,
        body: emailForm.value.body,
        propertyId: returnPropertyId(index),
        workOrderId: emailForm.value.workOrderId,
        propertyOfferId: emailForm.value.propertyId,
        certificateId: props.certificateId,
        tenancyId: emailForm.value.tenancyId,
        appointmentId: emailForm.value.appointmentId,
        propertyFeedbackContactId: props.propertyFeedbackContactId,
        cCs: emailForm.value.cCs,
        bcCs: emailForm.value.bcCs,
        setAsHighPriority: emailForm.value.setAsHighPriority,
        requestReadReceipt: emailForm.value.requestReadReceipt,
        autoCcLinkedContacts: emailForm.value.autoCcLinkedContacts,
        contactDocumentIds: emailForm.value.contactDocumentIds,
      });
    });
  } else {
    props.contactList.forEach((contact, index) => {
      emailFormsToSubmit.push({
        contactId: contact,
        templateId: props.emailTemplateId,
        subject: emailForm.value.subject,
        body: emailForm.value.body,
        propertyId: returnPropertyId(index),
        workOrderId: emailForm.value.workOrderId,
        propertyOfferId: emailForm.value.propertyId,
        certificateId: props.certificateId,
        tenancyId: emailForm.value.tenancyId,
        appointmentId: emailForm.value.appointmentId,
        propertyFeedbackContactId: props.propertyFeedbackContactId,
        cCs: emailForm.value.cCs,
        bcCs: emailForm.value.bcCs,
        setAsHighPriority: emailForm.value.setAsHighPriority,
        requestReadReceipt: emailForm.value.requestReadReceipt,
        autoCcLinkedContacts: emailForm.value.autoCcLinkedContacts,
        contactDocumentIds: emailForm.value.contactDocumentIds,
      });
    });
  }

  if (await sendEmail(emailFormsToSubmit)) {
    showCloseConfirmationPrompt.value = false;
    showModal.value = false;
    emit("emailSent");
    emit("modalClosed");
  }
};

const sendEmail = async (emailFormsToSubmit: EmailForm[]) => {
  try {
    sendingOrSaving.value = true;

    const response = await apiNextClient.httpPost<BulkEmailResponse>(
      "bulkemail/AddBulkEmails",
      emailFormsToSubmit,
    );

    await uploadAttachments(response.id);
    return true;
  } catch (err) {
    displayErrorMessage(getErrorMessage(err));
    return false;
  } finally {
    sendingOrSaving.value = false;
  }
};

// Code for uploading files
const uploadAttachments = async (emailId: number) => {
  if (!attachments.value || attachments.value.length == 0) {
    return;
  }

  if (await populateFilesList()) {
    await callAttachmentsApi(emailId);
  }
};

const populateFilesList = async () => {
  let bulkEmailAttachment = 0;
  attachments.value?.forEach((file) => {
    const correspondencAttachment = originalCorrespondenceFileList.value.find(
      (originalCorrespondenceAttachment) => {
        return originalCorrespondenceAttachment.name == file.name;
      },
    );
    if (!correspondencAttachment) {
      filesToSubmit.value.append(file.name, file);
      bulkEmailAttachment++;
    }
  });
  return bulkEmailAttachment;
};

const callAttachmentsApi = async (emailId: number) => {
  try {
    await apiNextClient.sendFormData(
      `bulkemail/${emailId}/UploadBulkEmailAttachments`,
      filesToSubmit.value,
    );
  } catch (err) {
    displayErrorMessage(getErrorMessage(err));
  }
};

// This next section is for functions triggered by user interactions with the modal.

// These are trigegered when users add contacts to the CC and BCC fields
const selectBlindCopyToContacts = () => {
  if (props.contactList.length > 1 || props.contactEnMasseList.length > 1) {
    return;
  }

  updateCopyContacts.value = false;
  openSelectCcContactModal.value = true;
};

const selectCopyToContacts = () => {
  if (props.contactList.length > 1 || props.contactEnMasseList.length > 1) {
    return;
  }

  updateCopyContacts.value = true;
  openSelectCcContactModal.value = true;
};

const updateCopyToContacts = (
  contacts: string,
  namesEmails: string,
  copyToContactIds: number[],
) => {
  copyToContactNames.value = contacts;
  emailForm.value.cCs = copyToContactIds;
  copyToContactsNamesEmails.value = namesEmails;
};

const updateBlindCopyToContacts = (
  contacts: string,
  blindCopyToContactsIds: number[],
) => {
  emailForm.value.bcCs = blindCopyToContactsIds;
  blindCopyToContactsNames.value = contacts;
};

// When the values of these fields change, we need to update the preview email body and subject displayed in the preview tab.
watch(
  () => emailForm.value.subject,
  async () => {
    await fetchPreviewSubjectBody();
  },
);

watch(
  () => emailForm.value.body,
  async () => {
    await fetchPreviewSubjectBody();
  },
);

watch(
  () => emailForm.value.propertyId,
  async () => {
    await fetchPreviewSubjectBody();
  },
);

const fetchPreviewSubjectBody = async () => {
  if (loading.value) {
    return;
  }

  await fetchAndDisplayDetailsBulletinNewsLetter();

  try {
    emailPreviewFields.value = await apiClient.httpPost(
      `app/correspondence/email/preview/mergefields`,
      {
        subject: emailForm.value.subject,
        body: emailForm.value.body,
        contactId: selectedContactId.value,
        propertyId: emailForm.value.propertyId,
        propertyOfferId: emailForm.value.propertyOfferId,
        appointmentId: emailForm.value.appointmentId,
        workOrderId: emailForm.value.workOrderId,
        certificateId: emailForm.value.certificateId,
        tenancyId: emailForm.value.tenancyId,
        propertyFeedbackContactId: emailForm.value.propertyFeedbackContactId,
      },
    );
  } catch (err) {
    displayErrorMessage(getErrorMessage(err));
    emailPreviewFields.value = {
      subject: "",
      body: "",
    };
  }
};

const fetchNewsLetterPreviewBody = async () => {
  try {
    newsLetterBody.value = await apiClient.httpPost<Body>(
      "app/correspondence/email/newsletter",
      {
        templateId: props.emailTemplateId,
        body: emailForm.value.body,
      },
    );
  } catch (err) {
    displayErrorMessage(getErrorMessage(err));
    return { body: "" };
  }
};

const fetchAndDisplayDetailsBulletinNewsLetter = async () => {
  if (
    emailTemplate.value?.typeId ==
      EmailTemplateTypes.PropertyBulletinAllProperties ||
    emailTemplate.value?.typeId ==
      EmailTemplateTypes.PropertyBulletinMatchedProperties
  ) {
    await fetchPropertyBulletinText();
    emailPreviewFields.value.body = propertyBulletinText.value.body;
  } else if (
    emailTemplate.value?.typeId == EmailTemplateTypes.PropertyDetails &&
    emailForm.value.propertyId > 0
  ) {
    await fetchPropertyDetails();
    emailPreviewFields.value.body = propertyDetails.value.body;
  } else if (emailTemplate.value?.typeId == EmailTemplateTypes.NewsLetter) {
    await fetchNewsLetterPreviewBody();
    emailPreviewFields.value.body = newsLetterBody.value.body;
  }

  var divToInsertHTMLInto = document.getElementById("preview-body");

  if (divToInsertHTMLInto) {
    divToInsertHTMLInto.innerHTML = emailPreviewFields.value.body;
  }
};

const fetchPropertyDetails = async () => {
  try {
    propertyDetails.value = await apiClient.httpPost(
      "app/correspondence/email/propertydetails",
      {
        templateId: props.emailTemplateId,
        propertyId: emailForm.value.propertyId,
        body: emailForm.value.body,
      },
    );
  } catch (err) {
    displayErrorMessage(getErrorMessage(err));
    propertyDetails.value = { body: "" };
  }
};

const fetchPropertyBulletinText = async () => {
  try {
    propertyBulletinText.value = await apiClient.httpPost(
      `app/correspondence/email/propertybulletin`,
      {
        contactId: selectedContactId.value,
        templateId: props.emailTemplateId,
        includeValuations: true,
        includeInstructed: true,
        body: emailForm.value.body,
      },
    );
  } catch (err) {
    displayErrorMessage(getErrorMessage(err));
    propertyBulletinText.value = { body: "", noPropertiesFound: false };
  }
};

// Code for adding merge fields
const addMergeField = (mergeField: String) => {
  if (addMergeFieldToSubject.value) {
    emailForm.value.subject = `${emailForm.value.subject} [${mergeField}]`;
    return;
  }

  bodyMergeFieldToAdd.value = `[${mergeField}]`;

  setTimeout(() => {
    bodyMergeFieldToAdd.value = "";
  }, 250);
};

const onInsertField = () => {
  openMergeFieldsModal.value = true;
};

const onHtmlEditorFocused = () => {
  addMergeFieldToSubject.value = false;
};

const onSubjectFieldFocused = () => {
  addMergeFieldToSubject.value = true;
};

// We need to add the selected contact's name and email address so we can display it in the preview tab at the appropriate time (when a user navighates to the contact).
const contactToSendToSelected = (selectedContact: ContactFindResult) => {
  if (!selectedContact) {
    return;
  }

  contactNamesEmails.value.push(
    `${selectedContact.name} ${selectedContact.emailAddress}`,
  );
};

// Triggered when a user adds or removes an attachment from the
const onAttachmentsChanged = (e: File[]) => {
  attachments.value = [...e];
};

// Double clicking a file should download it.
// First, we must check if the file to be downloaded is present in the original list of files fetched from the API.
// If it's present we can use the API to downloard the file so that we can get the correct file extension, otherwise,
// we just use the saveAs method.
const downloadAttachment = async (fileToDownload: File) => {
  const fileNameId = originalFilesIdsNames.value.find((record) => {
    return record.name == fileToDownload.name;
  });

  // If we are emailing a correspondence list item  or if we've jsut attached a document, we can't make the API call below as it'll fail - it's fetching the email template attachments.

  const correspondenceAttachment = props.correspondenceFileIDs.find((id) => {
    return id == fileNameId?.id;
  });
  if (!fileNameId || correspondenceAttachment) {
    saveAs(fileToDownload, fileToDownload.name);
    return;
  }

  await callDownloadApi(fileNameId.id);

  if (!downloadedFile.value) {
    return;
  }

  const blobToDownload = convertCorrespondenceFileToBlob(
    downloadedFile.value.attachedFile,
  );
  const fileNameParts = getFileNameParts(
    downloadedFile.value.attachedFile.fileDownloadName,
  );

  if (fileNameParts) {
    saveAs(blobToDownload, fileNameParts.nameWithExtension);
  }
};

const callDownloadApi = async (id: number) => {
  try {
    downloadedFile.value = await apiNextClient.httpGet(
      `email/${id}/emailattachment`,
    );
  } catch (err) {
    displayErrorMessage("The attachment could not be downloaded.");
    downloadedFile.value = undefined;
  }
};

// Functions for when users navigate through contacts on the preview tab
// The preview body must be updated whenever the displayed contact is changed
watch(
  () => currentContactPosition.value,
  (newVal, oldVal) => {
    // We need to set the property id to the corresponding property record's id
    emailForm.value.propertyId = returnPropertyId(currentContactPosition.value);
    selectedContactId.value = props.displaySelectContactsTab
      ? props.contactEnMasseList[currentContactPosition.value].id
      : props.contactList[currentContactPosition.value];

    // We don't want to update the contactNamesEmails list with the same contact info twice or more often unless we are
    // emailing contacts per property as a contact may be emailed multipled times if they
    // associated with multiple properties.
    // Also this is only triggered when a moving forward through contacts, not backwards then forwards when
    // emailing per property. Otherwise, a contact may be incorrectly displayed in the to field on the preview tab
    if (
      (!props.emailingContactsPerProperty &&
        !previouslyNavigatedThroughIds.value.find((id) => {
          return id == selectedContactId.value;
        })) ||
      (props.emailingContactsPerProperty &&
        newVal > oldVal &&
        newVal > furthestContactVisited.value)
    ) {
      furthestContactVisited.value = newVal;
      updatedNamesEmailList(
        selectedContactId.value,
        currentContactPosition.value,
      );
      previouslyNavigatedThroughIds.value.push(selectedContactId.value);
    }

    fetchPreviewSubjectBody();
  },
);

const displayPreviousContact = () => {
  // When we get to the start of the list of contacts, the user can no longer navigate to the previous contact
  if (currentContactPosition.value == 0) {
    return;
  }

  currentContactPosition.value--;
};

const displayNextContact = () => {
  // When we get to the end of the list of contacts, the user can no longer navigate to the next contact
  if (
    (!props.displaySelectContactsTab &&
      currentContactPosition.value == props.contactList.length - 1) ||
    (props.displaySelectContactsTab &&
      currentContactPosition.value == props.contactEnMasseList.length - 1)
  ) {
    return;
  }

  currentContactPosition.value++;
};

// Match contacts tab - functions relate to the editing of contact data
const editMatchedContactEmail = async (contact: MatchedContacts) => {
  if (!(await lockContact(contact.id))) {
    return;
  }

  await fetchMainData(contact.id);

  if (contactToEmail.value) {
    displayEditContactModal.value = true;
    toEditEmailId.value = contact.id;
  }
};

const editContactModalClosed = (contactUpdated: boolean, contact: Contacts) => {
  unLockContact();

  // Here we need to update the list with the correct email for the updated contact
  if (contact) {
    const index = copiedContactList.value.findIndex((matchedContact) => {
      return matchedContact.id == contact.id;
    });

    copiedContactList.value[index].email = contact.email;

    // The email displayed in the preview tab must also be updated
    if (contactNamesEmails.value.length >= index) {
      contactNamesEmails.value[index] =
        `${contact.firstNames} ${contact.lastName} - ${contact.email}, ${contact.emailAlt}`;
    }
  }

  // We must reset these to ensure that the selected contact's are displayed in the edit modal
  contactToEmail.value = undefined;
  toEditEmailId.value = -1;
};

const fetchMainData = async (contactId: number) => {
  try {
    contactToEmail.value = await apiClient.httpGet<Contacts>(
      `database/contacts/${contactId}`,
    );
  } catch (ex) {
    displayErrorMessage(getErrorMessage(ex));
    contactToEmail.value = undefined;
  }
};

// Locking fucntions
const lockContact = async (contactId: number) => {
  try {
    await apiClient.httpPostVoid(`database/contacts/${contactId}/lock`, {
      lock: true,
      extraInfo: "",
    });
    return true;
  } catch (err) {
    displayErrorMessage(getErrorMessage(err));
    return false;
  }
};

const unLockContact = async () => {
  try {
    await apiClient.httpPostVoid(
      `database/contacts/${toEditEmailId.value}/lock`,
      {
        lock: false,
        extraInfo: "",
      },
    );
  } catch (err) {
    displayErrorMessage(getErrorMessage(err));
  }
};

// This function handles users confirming they wish to keep the modal open.
const cancelPromptDenied = () => {
  keepingModalOpening.value = true;
};

const cancelPromptAccepted = () => {
  emit("cancelPromptAccepted");
  showModal.value = false;
};

// Logic for closing the modal
const modalClosed = () => {
  showPreviewTab.value = false;
  keepingModalOpening.value = false;
  emit("modalClosed");
};

const onCancelClick = () => {
  emit("modalClosed");
  showModal.value = false;
};

// If we are displaying a list of matched contacts, we don't need a 'To' field value
const toFieldRequierd = computed(() => {
  return props.displaySelectContactsTab
    ? props.contactEnMasseList.length == 1
    : props.contactList.length == 1;
});

const sendButtonDisabled = computed(() => {
  return (
    sendingOrSaving.value ||
    credits.value <= 0 ||
    contactNamesEmails.value.length == 0 ||
    (props.contactList.length == 0 && props.contactEnMasseList.length == 0) ||
    (contactNamesEmails.value[currentContactPosition.value] &&
      !contactNamesEmails.value[currentContactPosition.value].includes("@")) ||
    emailTemplate.value?.typeId ==
      EmailTemplateTypes.PropertyBulletinAllProperties ||
    (emailTemplate.value?.typeId ==
      EmailTemplateTypes.PropertyBulletinMatchedProperties &&
      propertyBulletinText.value.noPropertiesFound) ||
    (emailTemplate.value?.typeId == EmailTemplateTypes.PropertyDetails &&
      emailForm.value.propertyId == 0)
  );
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(ModalBase, {
      modelValue: showModal.value,
      "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((showModal).value = $event)),
      title: "Email",
      height: "835px",
      width: _unref(ModalWidth).Large,
      showCloseConfirmationPrompt: showCloseConfirmationPrompt.value,
      saving: sendingOrSaving.value,
      maxHeight: "90vh",
      customCloseConfirmationText: "Are you sure you want to close this email without sending?",
      onCancelPromptDenied: cancelPromptDenied,
      onCancelPromptAccepted: cancelPromptAccepted,
      onModalClosed: modalClosed,
      "help-page": "emailing",
      "loading-content": loading.value
    }, {
      content: _withCtx(() => [
        _createVNode(_unref(DxTabPanel), {
          "scroll-by-content": true,
          "show-nav-buttons": true,
          "swipe-enabled": false,
          selectedIndex: selectedTab.value,
          "onUpdate:selectedIndex": _cache[9] || (_cache[9] = ($event: any) => ((selectedTab).value = $event))
        }, {
          default: _withCtx(() => [
            _createVNode(_unref(DxItem), { title: "Customise" }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_1, [
                  _createVNode(AcquaintInfoBox, {
                    text: credits.value.toString(),
                    label: "Credits",
                    width: _unref(FieldSize).Small
                  }, null, 8, ["text", "width"]),
                  _createElementVNode("div", _hoisted_2, [
                    _createElementVNode("div", _hoisted_3, [
                      _createVNode(ContactLookup, {
                        modelValue: emailForm.value.contactId,
                        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((emailForm.value.contactId) = $event)),
                        label: "To",
                        validationGroup: "emailFormGroup",
                        readOnly: 
                    props.contactList.length > 0 ||
                    props.contactEnMasseList.length > 0
                  ,
                        onContactSelected: contactToSendToSelected,
                        isRequired: toFieldRequierd.value,
                        showNavigateContactIcon: false,
                        findNameOnIdChange: true
                      }, null, 8, ["modelValue", "readOnly", "isRequired"])
                    ]),
                    _createElementVNode("div", _hoisted_4, [
                      _createVNode(AcquaintInfoBox, {
                        label: "From",
                        text: azureEmailAddress.value
                      }, null, 8, ["text"])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_5, [
                    _createElementVNode("div", _hoisted_6, [
                      _createVNode(AcquaintInfoBox, {
                        label: "Copy To (CC)",
                        text: copyToContactNames.value,
                        icon: "spindown",
                        onIconClicked: selectCopyToContacts
                      }, null, 8, ["text"])
                    ]),
                    _createElementVNode("div", _hoisted_7, [
                      _createVNode(AcquaintInfoBox, {
                        label: "Blind Copy (BCC)",
                        text: blindCopyToContactsNames.value,
                        icon: "spindown",
                        onIconClicked: selectBlindCopyToContacts
                      }, null, 8, ["text"])
                    ])
                  ]),
                  _createVNode(AcquaintTextbox, {
                    label: "Subject",
                    modelValue: emailForm.value.subject,
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((emailForm.value.subject) = $event)),
                    requiredInput: true,
                    fieldValidation: _unref(EmailsValidation).Subject,
                    onOnFocused: onSubjectFieldFocused,
                    validationGroup: "emailFormGroup"
                  }, null, 8, ["modelValue", "fieldValidation"]),
                  _createVNode(HtmlEditor, {
                    modelValue: emailForm.value.body,
                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((emailForm.value.body) = $event)),
                    label: "Body",
                    "display-a-i-modal": true,
                    insertTextAtCursorPosition: bodyMergeFieldToAdd.value,
                    onOnFocused: onHtmlEditorFocused,
                    onAiIconClick: _cache[3] || (_cache[3] = () => (displayAIModal.value = true))
                  }, null, 8, ["modelValue", "insertTextAtCursorPosition"])
                ])
              ]),
              _: 1
            }),
            _createVNode(_unref(DxItem), { title: "Settings" }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_8, [
                  _createVNode(PropertyLookup, {
                    modelValue: emailForm.value.propertyId,
                    "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((emailForm.value.propertyId) = $event)),
                    label: "Property Related",
                    required: 
                emailTemplate.value?.typeId == _unref(EmailTemplateTypes).PropertyDetails
              ,
                    validationGroup: "emailFormGroup"
                  }, null, 8, ["modelValue", "required"]),
                  _createElementVNode("div", _hoisted_9, [
                    _createVNode(SwitchToggle, {
                      label: "Request Read Receipt",
                      labelWidth: "9.5rem",
                      modelValue: emailForm.value.requestReadReceipt,
                      "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((emailForm.value.requestReadReceipt) = $event)),
                      "read-only": false
                    }, null, 8, ["modelValue"]),
                    _createVNode(SwitchToggle, {
                      label: "Set as High Importance",
                      labelWidth: "9.5rem",
                      modelValue: emailForm.value.setAsHighPriority,
                      "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((emailForm.value.setAsHighPriority) = $event)),
                      "read-only": false
                    }, null, 8, ["modelValue"]),
                    _createVNode(SwitchToggle, {
                      label: "Auto CC Linked Contacts",
                      labelWidth: "9.5rem",
                      modelValue: emailForm.value.autoCcLinkedContacts,
                      "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((emailForm.value.autoCcLinkedContacts) = $event)),
                      "read-only": false
                    }, null, 8, ["modelValue"])
                  ])
                ])
              ]),
              _: 1
            }),
            _createVNode(_unref(DxItem), { title: "Attachments" }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_10, [
                  _createVNode(FileUpload, {
                    onFilesChanged: onAttachmentsChanged,
                    reset: resetFileField.value,
                    defaultFiles: attachments.value,
                    onFileDoubleClicked: downloadAttachment
                  }, null, 8, ["reset", "defaultFiles"])
                ])
              ]),
              _: 1
            }),
            _createVNode(_unref(DxItem), {
              title: "Preview",
              visible: showPreviewTab.value
            }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_11, [
                  _createVNode(AcquaintInfoBox, {
                    text: credits.value.toString(),
                    label: "Credits",
                    width: _unref(FieldSize).Small
                  }, null, 8, ["text", "width"]),
                  _createVNode(AcquaintInfoBox, {
                    label: "To",
                    text: contactNamesEmails.value[currentContactPosition.value]
                  }, null, 8, ["text"]),
                  _createVNode(AcquaintInfoBox, {
                    label: "Copy To (CC)",
                    text: copyToContactsNamesEmails.value
                  }, null, 8, ["text"]),
                  _createVNode(AcquaintInfoBox, {
                    label: "Subject",
                    text: emailPreviewFields.value.subject
                  }, null, 8, ["text"]),
                  (isMarketingHtmlEmailTemplate.value)
                    ? (_openBlock(), _createElementBlock("section", _hoisted_12, [
                        _hoisted_13,
                        _createElementVNode("div", _hoisted_14, [
                          _createVNode(ScrollView, null, {
                            default: _withCtx(() => [
                              _hoisted_15
                            ]),
                            _: 1
                          })
                        ])
                      ]))
                    : (_openBlock(), _createBlock(HtmlEditor, {
                        key: 1,
                        label: "Message Body",
                        modelValue: emailPreviewFields.value.body,
                        "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((emailPreviewFields.value.body) = $event)),
                        "read-only": true
                      }, null, 8, ["modelValue"])),
                  (
                props.contactList.length > 0 ||
                props.contactEnMasseList.length > 0
              )
                    ? (_openBlock(), _createElementBlock("section", _hoisted_16, [
                        _createElementVNode("div", _hoisted_17, [
                          _createElementVNode("i", {
                            class: "fas fa-chevron-left",
                            onClick: displayPreviousContact
                          }),
                          _createElementVNode("span", null, _toDisplayString(currentContactPosition.value + 1) + "/" + _toDisplayString(props.displaySelectContactsTab
                      ? props.contactEnMasseList.length
                      : props.contactList.length), 1),
                          _createElementVNode("i", {
                            class: "fas fa-chevron-right",
                            onClick: displayNextContact
                          })
                        ])
                      ]))
                    : _createCommentVNode("", true)
                ])
              ]),
              _: 1
            }, 8, ["visible"]),
            _createVNode(_unref(DxItem), {
              title: "Selected Contacts",
              visible: props.displaySelectContactsTab,
              height: "700px"
            }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_18, [
                  _createVNode(GridBase, {
                    "data-source": copiedContactList.value,
                    wordWrapEnabled: true,
                    customColumnSlots: ['emailCell', 'includeCell'],
                    displayPages: true
                  }, {
                    columns: _withCtx(() => [
                      _createVNode(_unref(DxColumn), {
                        "data-field": "id",
                        caption: "Id",
                        visible: false
                      }),
                      _createVNode(_unref(DxColumn), {
                        "data-field": "name",
                        caption: "Name",
                        "hiding-priority": 6,
                        width: "350px"
                      }),
                      _createVNode(_unref(DxColumn), {
                        "data-field": "email",
                        caption: "Email",
                        "hiding-priority": 5,
                        "cell-template": "emailCell",
                        width: "475px"
                      }),
                      _createVNode(_unref(DxColumn), {
                        "data-field": "include",
                        caption: "Include",
                        "hiding-priority": 5,
                        "cell-template": "includeCell"
                      })
                    ]),
                    emailCellData: _withCtx(({ data }) => [
                      _createElementVNode("div", _hoisted_19, [
                        _createElementVNode("span", _hoisted_20, _toDisplayString(data.email), 1),
                        _createElementVNode("i", {
                          class: "fas fa-pencil-alt",
                          onClick: ($event: any) => (editMatchedContactEmail(data))
                        }, null, 8, _hoisted_21)
                      ])
                    ]),
                    includeCellData: _withCtx(({ data }) => [
                      _createElementVNode("div", _hoisted_22, [
                        _createVNode(SwitchToggle, {
                          label: "",
                          labelWidth: "0rem",
                          modelValue: data.include,
                          "onUpdate:modelValue": ($event: any) => ((data.include) = $event),
                          "read-only": false
                        }, null, 8, ["modelValue", "onUpdate:modelValue"])
                      ])
                    ]),
                    _: 1
                  }, 8, ["data-source"])
                ])
              ]),
              _: 1
            }, 8, ["visible"])
          ]),
          _: 1
        }, 8, ["selectedIndex"])
      ]),
      footer: _withCtx(() => [
        _createVNode(_unref(DxToolbarItem), {
          widget: "dxButton",
          toolbar: "bottom",
          location: "before",
          options: {
          text: 'Insert Field',
          onClick: () => {
            onInsertField();
          },
          disabled: sendingOrSaving.value,
          visible: selectedTab.value == 0,
        }
        }, null, 8, ["options"]),
        _createVNode(_unref(DxToolbarItem), {
          widget: "dxButton",
          toolbar: "bottom",
          location: "after",
          options: {
          text: 'Send',
          onClick: (e) => {
            onSendClick(e);
          },
          disabled: sendButtonDisabled.value,
          validationGroup: 'emailFormGroup',
        }
        }, null, 8, ["options"]),
        _createVNode(_unref(DxToolbarItem), {
          widget: "dxButton",
          toolbar: "bottom",
          location: "after",
          options: {
          text: 'Cancel',
          onClick: () => {
            onCancelClick();
          },
          disabled: sendingOrSaving.value,
        }
        }, null, 8, ["options"])
      ]),
      _: 1
    }, 8, ["modelValue", "width", "showCloseConfirmationPrompt", "saving", "loading-content"]),
    _createVNode(AITextGeneratorModal, {
      modelValue: displayAIModal.value,
      "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((displayAIModal).value = $event))
    }, null, 8, ["modelValue"]),
    _createVNode(SelectCcContactsModal, {
      modelValue: openSelectCcContactModal.value,
      "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((openSelectCcContactModal).value = $event)),
      onSaveCopyToContacts: updateCopyToContacts,
      isPrimaryContact: contactSummary.value?.isPrimaryContact ?? false,
      onSaveBlindCopyToContacts: updateBlindCopyToContacts,
      copyTo: updateCopyContacts.value,
      clearLists: clearLists.value,
      contactId: selectedContactId.value
    }, null, 8, ["modelValue", "isPrimaryContact", "copyTo", "clearLists", "contactId"]),
    _createVNode(MergeFieldsModal, {
      modelValue: openMergeFieldsModal.value,
      "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((openMergeFieldsModal).value = $event)),
      onAddMergeField: addMergeField
    }, null, 8, ["modelValue"]),
    (contactToEmail.value)
      ? (_openBlock(), _createBlock(EditContactDetails, {
          key: 0,
          modelValue: displayEditContactModal.value,
          "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((displayEditContactModal).value = $event)),
          showAddressField: false,
          onModalClosed: editContactModalClosed,
          contact: contactToEmail.value
        }, null, 8, ["modelValue", "contact"]))
      : _createCommentVNode("", true)
  ], 64))
}
}

})